import type {FetchBaseQueryArgs} from '@reduxjs/toolkit/query';
import {MasterLocale} from 'localization/types';
import type {RootState} from '../types';
import {getOidcUser} from './getOidcUser';

export const prepareHeaders: FetchBaseQueryArgs['prepareHeaders'] = (
  headers: Headers,
  {getState},
): Headers => {
  // Set up locale
  const locale =
    (getState() as RootState).settings.preferredLocale ?? MasterLocale;
  headers.set('Accept-Language', locale);

  // Authorization to EBS from OIDC state
  headers.set('Authorization', getOidcUser()?.access_token || '');
  headers.set('Authentication-Info', getOidcUser()?.id_token || '');

  return headers;
};
